import { ReactNode } from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { Fonts } from '@/constants/theme';

type Props = {
  accent: string;
  description: string;
  onSignOut: () => void;
  roleLabel: string;
  title: string;
  children?: ReactNode;
};

export function RoleHome({
  accent,
  children,
  description,
  onSignOut,
  roleLabel,
  title,
}: Props) {
  return (
    <SafeAreaView style={styles.safeArea}>
      <View style={styles.screen}>
        <View style={[styles.glow, { backgroundColor: accent }]} />

        <View style={styles.heroCard}>
          <Text style={[styles.eyebrow, { color: accent }]}>{roleLabel}</Text>
          <Text style={styles.title}>{title}</Text>
          <Text style={styles.description}>{description}</Text>
        </View>

        <View style={styles.content}>{children}</View>

        <Pressable onPress={onSignOut} style={styles.signOutButton}>
          <Text style={styles.signOutText}>Sign out</Text>
        </Pressable>
      </View>
    </SafeAreaView>
  );
}

export function FeatureCard({ body, title }: { body: string; title: string }) {
  return (
    <View style={styles.featureCard}>
      <Text style={styles.featureTitle}>{title}</Text>
      <Text style={styles.featureBody}>{body}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  screen: {
    flex: 1,
    backgroundColor: '#FFFFFF',
    paddingHorizontal: 20,
    paddingTop: 16,
    paddingBottom: 24,
    gap: 18,
  },
  glow: {
    position: 'absolute',
    width: 220,
    height: 220,
    borderRadius: 999,
    top: -70,
    right: -80,
    opacity: 0.35,
  },
  heroCard: {
    borderRadius: 28,
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: '#D5E2D7',
    padding: 22,
    gap: 10,
    shadowColor: '#0D2B1A',
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.08,
    shadowRadius: 20,
    elevation: 4,
  },
  eyebrow: {
    fontSize: 12,
    fontFamily: Fonts.rounded,
    fontWeight: '700',
    letterSpacing: 0.8,
    textTransform: 'uppercase',
  },
  title: {
    color: '#173924',
    fontSize: 30,
    lineHeight: 35,
    fontFamily: Fonts.rounded,
    fontWeight: '700',
    letterSpacing: -0.6,
  },
  description: {
    color: '#5D7162',
    fontSize: 15,
    lineHeight: 22,
    fontFamily: Fonts.serif,
  },
  content: {
    gap: 12,
  },
  featureCard: {
    borderRadius: 22,
    backgroundColor: '#F8FBF8',
    borderWidth: 1,
    borderColor: '#DCE7DE',
    padding: 18,
    gap: 6,
  },
  featureTitle: {
    color: '#173924',
    fontSize: 16,
    fontWeight: '700',
    fontFamily: Fonts.rounded,
  },
  featureBody: {
    color: '#65786A',
    fontSize: 14,
    lineHeight: 21,
  },
  signOutButton: {
    minHeight: 54,
    borderRadius: 18,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#1F5A37',
  },
  signOutText: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: '700',
    fontFamily: Fonts.rounded,
  },
});
